__turbopack_context__.v({
  "contentWrapper": "XEfLFG_contentWrapper",
  "ctaButton": "XEfLFG_ctaButton",
});
